import { render } from "./privacyAgreement.vue?vue&type=template&id=6608d096&scoped=true"
import script from "./privacyAgreement.vue?vue&type=script&lang=js"
export * from "./privacyAgreement.vue?vue&type=script&lang=js"

import "./privacyAgreement.vue?vue&type=style&index=0&id=6608d096&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6608d096"]])

export default __exports__